const playSoundWeb = async () => {
  const {Audio} = await import('expo-av'); // Dynamic import for expo-av
  const {sound} = await Audio.Sound.createAsync(
    require('assets/sounds/chime.mp3'), // Ensure this path is correct
  );
  await sound.playAsync();
};

export default playSoundWeb;
